/*
https://github.com/atlassian/react-beautiful-dnd 
https://codesandbox.io/s/k260nyxq9v
 */

import React from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import { withStyles } from "@material-ui/core/styles";

import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import SaveIcon from "@material-ui/icons/Save";
import UpdateIcon from "@material-ui/icons/Update";
import BarChartTwoToneIcon from "@material-ui/icons/BarChartTwoTone";
import WebIcon from "@material-ui/icons/Web";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import AssistantIcon from "@material-ui/icons/Assistant";
import TextFields from "@material-ui/icons/TextFields";
import Delete from "@material-ui/icons/Delete";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { platformHandler } from "../platforms/PlatformHandler";
import { languageManager } from "../utils/languageManager";
import WebViewFW from "../components/flipwitComponents/WebViewFW";
import { FwScene } from "./FwScene";
import FwModalLoader from "../components/FwModalLoader";
import { PluginHandler } from "../utils/pluginHandler";
import { selectCurrentData } from "../App/selectors";
import { requestPostSail } from "../utils/requester";
import SelectPDF from "../components/SelectPDF";
import DialogUpload from "../components/DialogUpload";
import { ID_SLIDE_COMMENT } from "../App/constants";

const singleStyles = {
  selectedId: {
    color: "#c12b2b",
  },

  selectedImg: {
    border: "solid #c12b2b 3px",
  },
};

const TOGLEA_PREFIX_NOTE = "[TOGLEA]-";

const originalWidthPreviewBar = 300;

const webViewsPrueba = {
	//Este es el que se muestra dentro al abrir el editor de un plugin
	//urlPluginEditor:"http://192.168.1.53:3001",
};


const styles = (theme) => {
  return {
    generalContainer: {
      width: "100%",
      height: "100%",
    },

    upperMenu: {
      height: 130,
      backgroundColor: "#eaeaea",
    },

    bottomContainer: {
      height: `${window.innerHeight - 64 - 130}px`,
      display: "flex",
      flexDirection: "row",
    },

    slideBar: {
      height: "100%",
      width: originalWidthPreviewBar,
      backgroundColor: "#d0d0d0",
      borderRight: "solid #a0a0a0 1px",
      paddingTop: "15px",
      overflowY: "scroll",
    },

    workspace: {
      display: "flex",
      flex: 1,
      backgroundColor: "#d0d0d0",
      position: "relative",
    },

    divTogglePreviews: {
      position: "absolute",
      left: "0px",
      top: "8px",
      width: "28px",
      height: "100px",
      backgroundColor: "#ff5722",
      borderRadius: "0px 15px 15px 0px",
      cursor: "pointer",
      color: "white",
      "& > svg": {
        marginTop: "5px",
        transition: "all 0.2s ease-in",
        transform: "rotateZ(180deg)",
      },
      "& > div": {
        transform: "rotateZ(-90deg)",
        transformOrigin: "center right",
        position: "absolute",
        bottom: "59%",
        right: "50%",
        fontWeight: "700",
      },
    },

    mirror: {
      transform: "rotateZ(0deg) !important",
    },

    prevPanelHidden: {
      width: "0% !important",
    },

    previewContainer: {
      width: "90%",
      margin: "auto",
      display: "flex",
      flexDirection: "row",
      margin: "20px auto",
    },

    divIndexPreview: {
      textAlign: "right",
      paddingRight: "10px",
      fontFamily: 'roboto-medium',
    },

    divImgPreview: {
      width: "calc( 100% - 30px)",
    },

    divLoaderPreview: {
      width: "100%",
      height: "128px",
      backgroundColor: "white",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    imgPreview: {
      width: "100%",
      display: "none",
    },

    selectedSlide: {
      width: "100%",
      objectFit: "contain",
      padding: "8px",
    },

    circular: {
      outline: "0px solid transparent",
      color: theme.palette.secondary.main,
    },
    gridList: {
      flexWrap: "nowrap",
      display: "flex",
      height: "100%",
      margin: "0px",
      overflow: 'auto',

      "& button:first-child" : {
        marginLeft: theme.spacing.unit * 2,
      }
    },
    iconPlay: {
      color: "limegreen !important",
      transform: "scaleX(1.2) scaleY(1.2)",
    },
    actionButton: {
      padding: 0,
      marginRight: theme.spacing.unit * 2,
      flex: "1",
      fontSize: "0.8em",
      justifyContent: "start",
      display: "flex",
      flexDirection: "column",
      minWidth: 'auto',
    },
    actionButtonLabel: {
      flexDirection: "column",
      marginTop: "8px",
    },
    iconQuestion: {
      backgroundColor: "black",
      color: "white",
      borderRadius: "5px",
      width: 30,
      height: 30,
    },
    icons: {
      width: 40,
      height: 40,
      color: "lightslategrey",
    },

    divWebview: {
      position: "fixed",
      width: "100%",
      height: "90%",

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& > iframe': {
        backgroundColor: 'white',
        padding: 10, 
        margin: 10,        
      },

      ['@media (max-width: 600px)']: {      
        height: 'calc( 100% - 64px )',
        position: 'absolute',
        '& > iframe': {
          margin: 0,        
        }
      },
    },

    leftInfo: {
      display: "flex",
      flexDirection: "column",
    },

    deleteIcon: {
      marginTop: "10px",
      cursor: "pointer",
      color: '#505050',
    },

    iconContainer: {
      width: "48px",
      height: "48px",
    },

    iframe: {
      backgroundColor: "white",
    },

    divLoader: {
      width: "100%",
      height: "100%",
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#FFF8",
    },

    slideBarContainer: {
      transition: "all 0.2s ease-in",
      overflowY: "hidden",
      width: originalWidthPreviewBar,
    },
  };
};

const dataIcons = [
  {
    icon: "play",
    langWord: "PLAY_OPTION",
  },
  {
    icon: "save",
    langWord: "SAVE_OPTION",
  },
  {
    icon: "update",
    langWord: "UPDATE_OPTION",
  },
  {
    icon: "survey",
    langWord: "INSERT_SURVEY",
  },
  {
    icon: "word",
    langWord: "INSERT_WORD_CLOUD",
  },
  {
    icon: "url",
    langWord: "INSERT_URL",
  },
  {
    icon: "youtube",
    langWord: "INSERT_YOUTUBE",
  },
  {
    icon: "tutorial",
    langWord: "INSERT_TUTORIAL",
  },
];

class SlideEditor extends FwScene {
  state = {
    showLoader: false,
    slides: [],
    selected: 0,
    imageHash: Date.now(),
    selectedId: 1,
    showPrevPanel: true,    
  };

  constructor(props) {
    super(props);
    this.pluginHandler = new PluginHandler();
    this.isDirty = false;
  }

  componentDidMount() {
    platformHandler.checkTitleBarScene("SlideEditor");

    this.setState({ showLoader: true });

    //Obtiene la informacion de las diapositivas para el id actual seleccionado en
    //platformHandler
    platformHandler.getSlidesInfo(
      platformHandler.cloudPresentationID,
      this.slidesRetrieved
    );

    platformHandler.setSlideEditor(this);

    document.addEventListener("keydown", this.deleteKeyPressed, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.deleteKeyPressed, false);
  }

  deleteKeyPressed = (e) => {
    console.log("SlideEditor -> deleteKeyPressed -> e.keyCode", e.key);
    if (e.key === "Delete" || e.key === "Backspace") {
      this.deleteSlide(this.state.selected);
    }
  };

  setShowPreviews = (newShowVal) => {
    this.setState({ showPrevPanel: newShowVal });
  };

  //Funcion que se llama cuando llega la informacion de los slides
  slidesRetrieved = (presentationInfo) => {
    console.log("Va a dejar2", presentationInfo.slides);

    for (var i = presentationInfo.slides.length - 1; i >= 0; i--) {
      presentationInfo.slides[i].id = "item-" + i;
    }

    this.setState({
      showLoader: false,
      slides: presentationInfo.slides,
      imageHash: Date.now(),
    });
  };

  getSlidesPreviews = () => {
    const { classes } = this.props;
    const { imageHash } = this.state;

    var allImgs = this.state.slides.map((item, i) => {
      return (
        <Draggable key={item.id} draggableId={item.id} index={i}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              key={"previewContainer" + i}
              className={classes.previewContainer}
              onClick={() => {
                this.selectSlide(i);
              }}
            >
              <div className={classes.leftInfo}>
                <div
                  className={classes.divIndexPreview}
                  style={
                    i == this.state.selected ? singleStyles.selectedId : {}
                  }
                >
                  {i + 1}
                </div>
                <div
                  onClick={() => {
                    this.deleteSlide(i);
                  }}
                >
                  <Delete className={classes.deleteIcon} />
                </div>
              </div>
              <div className={classes.divImgPreview}>
                <div
                  id={"loaderPreview" + i}
                  className={classes.divLoaderPreview}
                >
                  <CircularProgress size={50} className={classes.circular} />
                </div>
                <img
                  key={"preview" + i}
                  id={"preview" + i}
                  style={
                    i == this.state.selected ? singleStyles.selectedImg : {}
                  }
                  src={`${this.state.slides[i].url}${
                    this.state.slides[i].url.indexOf("?") >= 0 ? "&" : "?"
                  }${imageHash}`}
                  className={classes.imgPreview}
                  onLoad={() => {
                    document.getElementById("preview" + i).style.display =
                      "block";
                    const loaderPreview = document.getElementById(
                      "loaderPreview" + i
                    );
                    if (loaderPreview) {
                      loaderPreview.remove();
                    }
                  }}
                />
              </div>
            </div>
          )}
        </Draggable>
      );
    });

    return allImgs;
  };

  selectSlide = (selected) => {
    const { slides } = this.state;
    this.setState({ selected, selectedId: slides[selected].idSlide });
  };

  //---------------------------------------------------

  // a little function to help us with reordering the result
  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? "lightblue" : "lightgrey",
    padding: 8,
    width: 250,
  });

  onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const slides = this.reorder(
      this.state.slides,
      result.source.index,
      result.destination.index
    );

    const { selectedId } = this.state;
    const selected = slides.findIndex((slide) => slide.idSlide === selectedId);
    this.isDirty = true;
    this.setState({
      slides,
      selected,
    });
  };

  getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: 8 * 2,
    margin: `0 0 8px 0`,

    // change background colour if dragging
    background: isDragging ? "lightgreen" : "grey",

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  createSavePayload = () => {
    let payloadMd5Data = {};

    payloadMd5Data.pptName = platformHandler.getPPTName();
    payloadMd5Data.userId = platformHandler.getUser();

    const slides = this.state.slides; // copy
    payloadMd5Data.slides = slides.map((slide, index) => ({
      idSlide: index + 1,
      md5: "",
      note: slide.note,
      url: slide.url,
    }));
    return payloadMd5Data;
  };

  saveSlides = (cb) => {
    this.setState({ showLoader: true });
    const payloadMd5Data = this.createSavePayload();

    requestPostSail(
      process.env.REACT_APP_URL_SERVICES + "slides/updateAllSlides",
      payloadMd5Data,
      (data) => {
        this.setState({ showLoader: false });
        if (cb) {
          cb();
        } else {
          this.openModal({
            title: languageManager.getLangWord("CONFIRMATION"),
            message: languageManager.getLangWord("STATES_INIT_PRESENTATION.2"),
          });
        }
      }
    );
  };

  startSlides = () => {
    platformHandler.presentationStarted(
      platformHandler.getPPTName(),
      true,
      platformHandler.cloudPresentationID
    );
  };

  askSaveBeforeAction = (title, message, action, actionCancel) => {
    if(this.isDirty) {
      this.openModal({
        title,
        message,
        buttons: [
          {
            label: languageManager.getLangWord("YES"),
            callback: () => this.saveSlides(action),
          },
          { label: languageManager.getLangWord("NO"), 
            callback: actionCancel
          },
        ],
      });
    }
    else {
      action();
    }
  }

  onMenuItemClick = (actionClicked) => () => {
    console.log("actionClicked", actionClicked);
    let newUrl = "";
    let suffixUrl = "?" + new Date().getTime();

    //TODO2
    //let urlPlugins = "./plugins";
    //let urlPlugins = "./pluginsTest";
    let urlPlugins = "https://app.flipwit.com/pluginsTest";
    switch (actionClicked) {
      case "play":
        this.askSaveBeforeAction(languageManager.getLangWord("CONFIRMATION"),
          languageManager.getLangWord("CONFIRMATION_START_PDF"),
          this.startSlides);
        return;
      case "update":
        this.openModal({
          title: languageManager.getLangWord("CONFIRMATION"),
          message: languageManager.getLangWord("CONFIRMATION_UPDATE_PDF"),
          buttons: [
            {
              label: languageManager.getLangWord("YES"),
              callback: () => this.refs.fileUploader.click(),
            },
            { label: languageManager.getLangWord("NO") },
          ],
        });

        return;
      case "save":
        this.saveSlides();
        return;
      case "survey":
        newUrl = urlPlugins + "/survey/editor/index.html";
        break;
      case "word":
        newUrl = urlPlugins + "/wordcloud/editor/index.html";
        break;
      case "url":
        newUrl = urlPlugins + "/url/editor/index.html";
        break;
      case "youtube":
        newUrl = urlPlugins + "/youtube/editor/index.html";
        break;
      case "tutorial":
        newUrl = urlPlugins + "/connection/editor/index.html";
        break;
    }

    newUrl = newUrl + suffixUrl;
    this.setState({ currentUrl: newUrl, loadingPlugin: true });
  };

  getIcon = (icon, classes) => {
    switch (icon) {
      case "save":
        return <SaveIcon className={classes.icons} />;
      case "update":
        return <UpdateIcon className={classes.icons} />;
      case "play":
        return (
          <PlayArrowIcon
            className={[classes.icons, classes.iconPlay].join(" ")}
          />
        );
      case "survey":
        return <BarChartTwoToneIcon className={classes.icons} />;
      case "word":
        return <TextFields className={classes.icons} />;
      case "url":
        return <WebIcon className={classes.icons} />;
      case "youtube":
        return <VideoLibraryIcon className={classes.icons} />;
      case "tutorial":
        return <AssistantIcon className={classes.icons} />;
    }
  };

  getUpperMenu = (classes) => {
    return (
      <div className={classes.gridList}>
        {dataIcons.map((dataIcon, index) => (
          <Button
            className={classes.actionButton}
            classes={{ label: classes.actionButtonLabel }}
            onClick={this.onMenuItemClick(dataIcon.icon)}
            key={index}
          >
            <div className={classes.iconContainer}>
              {this.getIcon(dataIcon.icon, classes)}
            </div>
            <div>{languageManager.getLangWord(dataIcon.langWord)}</div>
          </Button>
        ))}
      </div>
    );
  };

  showSelectedSlide = (classes) => {
    const { slides, selected, imageHash } = this.state;

    return slides && slides[selected] ? (
      <img
        src={`${slides[selected].url}${
          slides[selected].url.indexOf("?") >= 0 ? "&" : "?"
        }${imageHash}`}
        className={classes.selectedSlide}
      />
    ) : null;
  };

  onReceiveMessage = (msg) => {
    if (msg === undefined) return;
    console.log("recibio mode: ", msg, this.props.currentData);
    try {
      let jsonMsg = JSON.parse(msg);

      this.pluginHandler.messageFromWebPlugin(
        jsonMsg,
        this.pluginViewer,
        this.props.currentData
      );
    } catch (e) {
      console.log("ERROR EN JSON", msg, e);
    }
  };

  backPressed = () => {
    if(this.state.currentUrl) {
      this.setState({ currentUrl: "" })
    }
    else {
      this.askSaveBeforeAction(languageManager.getLangWord("CONFIRMATION"),
            languageManager.getLangWord("CONFIRMATION_BACK_PDF"),
            () => { platformHandler.openScene("SelectPresentation"); },
            () => { platformHandler.openScene("SelectPresentation"); });
    }
  };

  deleteSlide = (index) => {
    this.openModal({
      title: languageManager.getLangWord("CONFIRMATION"),
      message: languageManager.getLangWord("CONFIRMATION_DELETE_SLIDE"),
      buttons: [
        {
          label: languageManager.getLangWord("YES"),
          callback: () => {
            const newItems = this.state.slides.slice(0); // copy
            newItems.splice(index, 1);
            this.isDirty = true;
            this.setState({ slides: newItems });
          },
        },
        { label: languageManager.getLangWord("NO") },
      ],
    });
  };

  insertActivity = (id, urlImg, pptName, comment, webView) => {
    console.log(
      "insertActivity -> id, urlImg, pptName, comment, webView",
      id,
      urlImg,
      pptName,
      comment,
      webView
    );

    const idTemp = new Date().getTime();

    const newItems = this.state.slides.slice(0); // copy
    newItems.splice(this.state.selected + 1, 0, {
      idSlide: idTemp,
      md5: "",
      note: `${ID_SLIDE_COMMENT}${id}\r\r${comment}`,
      url: urlImg,
      id: idTemp,
    });

    this.isDirty = true;
    this.setState({ showLoader: false, slides: newItems, currentUrl: "" });
    this.openModal({
      title: languageManager.getLangWord("CONFIRMATION"),
      message: languageManager.getLangWord("ACTIVITY_INSERTED"),
    });    

    if (webView != null) {
      var resp = {
        source: "flipwit",
        cmd: "insertActCB",
        success: true,
        id: id,
      };

      webView.sendMessage(JSON.stringify(resp));
    }
  };

  onHandleReady = () => {
    this.setState({ loadingPlugin: false });
  };

  onChangeFile = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const file = event.target.files[0];
    this.setState({ file, uploadPDF: true, showLoader: true }); /// if you want to upload latter
  };

  onProgressPDF = (showLoader, uploadingPPT) => {
    this.setState({
      uploadingPPT,
      showLoader,
    });
  };

  onFinished = (name, id, slidesPDF) => {
    let { slides } = this.state;

    const onlyPDFSlides = slidesPDF.slides.filter(
      (slide) => slide.note.indexOf(ID_SLIDE_COMMENT) < 0
    );

    let indexPDF = 0;
    let countTogleaSlides = 0;

    // solo se actualizan los slides, no se agregan o borran para evitar comportamientos extraños ( borrar en loops )
    slides.forEach((slide, index) => {
      if (slide.note.indexOf(TOGLEA_PREFIX_NOTE) < 0) {
        if (onlyPDFSlides.length > indexPDF) {
          slides[index] = onlyPDFSlides[indexPDF];
          indexPDF++;
        }
      } else {
        countTogleaSlides++;
      }
    });

    const countPDFAndTogleaSlides = onlyPDFSlides.length + countTogleaSlides;

    if (slides.length > countPDFAndTogleaSlides) {
      slides = slides.filter((slide, index) => {
        return (
          slide.note.indexOf(TOGLEA_PREFIX_NOTE) >= 0 ||
          index < countPDFAndTogleaSlides
        );
      });
    } else if (slides.length < countPDFAndTogleaSlides) {
      slides.push(...onlyPDFSlides.slice(slides.length - countTogleaSlides));
    }

    this.slidesRetrieved({ slides });
    this.setState({ uploadPDF: false, uploadingPPT: false }, () => {
      this.saveSlides();
    });
  };

  showWebView = (classes) => {

    var urlPluginEditor = this.state.currentUrl;
    if(webViewsPrueba.urlPluginEditor!==undefined) {
			urlPluginEditor = webViewsPrueba.urlPluginEditor;
		}

    return (
      <div className={classes.divWebview}>
        {this.state.loadingPlugin && (
          <React.Fragment>
            <div className={classes.divLoader}>
              <CircularProgress size={50} style={{ position: "absolute" }} />
            </div>
          </React.Fragment>
        )}
        <WebViewFW
          ref={(child) => {
            this.pluginViewer = child;
          }}
          name="pluginViewerEditor"
          //urlWebView={ "http://localhost:3001/?"  + this.date  }
          urlWebView={urlPluginEditor}
          //urlWebView={ "http://192.168.1.53/flipwit_plugins/static/survey/editor/?" + this.date }
          //pointerEvents={"none"}
          height={"100%"}
          //idToglea={ currentData.idToglea }
          handleReceiveMessage={this.onReceiveMessage}
          //handleReceiveMessage={this.onReceiveMessage}
          handleReady={this.onHandleReady}
          className={classes.iframe}
          //onClick={() => {if(platformHandler.isFullScreen()) this.onButtonPress("Next", true)}}
        />
      </div>
    );
  };

  //---------------------------------------------------

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        {this.state.showLoader && <FwModalLoader />}
        {this.state.uploadPDF && (
          <SelectPDF
            hideComponent
            file={this.state.file}
            classes={classes}
            onProgress={this.onProgressPDF}
            onFinished={this.onFinished}
          />
        )}
        <input
          type="file"
          id="file"
          ref="fileUploader"
          style={{ display: "none" }}
          onChange={this.onChangeFile}
        />
        <div className={classes.generalContainer}>
          <div className={classes.upperMenu}>{this.getUpperMenu(classes)}</div>
          <div className={classes.bottomContainer}>
            <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided, snapshot) => {
                  return (
                    <div
                      className={[
                        classes.slideBarContainer,
                        this.state.showPrevPanel ? "" : classes.prevPanelHidden,
                      ].join(" ")}
                    >
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        className={classes.slideBar}
                      >
                        {this.getSlidesPreviews()}
                        {provided.placeholder}
                      </div>
                    </div>
                  );
                }}
              </Droppable>
            </DragDropContext>
            <div
              className={classes.workspace}
              onClick={() => {
                this.setShowPreviews(!this.state.showPrevPanel);
              }}
            >
              <div className={classes.divTogglePreviews}>
                <PlayArrowIcon
                  className={this.state.showPrevPanel ? "" : classes.mirror}
                ></PlayArrowIcon>
                <div>{languageManager.getLangWord("TOGGLE_PREVIEW_BTN")}</div>
              </div>
              {this.showSelectedSlide(classes)}
            </div>
          </div>
        </div>
        {this.state.uploadingPPT && <DialogUpload />}
        {this.state.currentUrl && this.showWebView(classes)}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.containers.appReducer.language,
    currentData: selectCurrentData(state),
  };
};

SlideEditor.contextTypes = {
  store: PropTypes.object,
};

SlideEditor.propTypes = {
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object,
};

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(SlideEditor)
);



// WEBPACK FOOTER //
// ./src/containers/scenes/SlideEditor.js